import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

const styles = StyleSheet.create({
    section: {
        flexGrow: 1,
        textAlign: "center",
        position: "relative",
        width: "100%",
        height: "100%",
    },
    titleContainer: {
        marginTop: 20,
        marginBottom: 50,
        padding: "0px 0px 20px 0px",
    },
    titleText: {
        fontWeight: "600",
        fontSize: "16px",
    },
    infoContainer: {
        margin: "0px 60px 0px 60px",
        fontSize: "16px",
        lineHeight: 1.8,
        textAlign: "left",
    },
    infoRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: "10px 0",
        fontSize: "14",
    },
    infoItemTitle: {
        color: "#1a73e8",
        fontWeight: 600,
    },
    infoItemValue: {
        fontWeight: 500,
        maxWidth: "55%",
        textAlign: "right",
    },
});

const InfoRow = ({ label, value }) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    return (
        <View style={styles.infoRow}>
            <Text style={styles.infoItemTitle}>{label}</Text>
            <Text style={styles.infoItemValue}>{value}</Text>
        </View>
    );
};

const FirstPageContent = ({
    t,
    exportedAt,
    user,
    cover = {},
}) => {
    const createdBy =
        user?.first_name || user?.last_name
            ? `${user?.first_name || ""} ${user?.last_name || ""}`.trim()
            : null;

    return (
        <View style={styles.section}>
            <View style={styles.titleContainer}>
                <Text style={styles.titleText}>
                    {t("EU AI Act – Provider CE Conformity Assessment")}
                </Text>
            </View>

            <View style={styles.infoContainer}>
                <InfoRow label={t("Software")} value={cover.name} />
                <InfoRow label={t("Version")} value={cover.version} />
                <InfoRow label={t("Provider")} value={cover.provider} />
                <InfoRow
                    label={t("AI Risk")}
                    value={cover.aiRiskLabel ? t(cover.aiRiskLabel) : null}
                />
                <InfoRow
                    label={t("CE Status")}
                    value={cover.statusLabel ? t(cover.statusLabel) : null}
                />
                <InfoRow label={t("Created By")} value={createdBy} />
                <InfoRow label={t("Exported At")} value={exportedAt} />
            </View>
        </View>
    );
};

export default withNamespaces()(FirstPageContent);
